'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.comment = null;



//////////////////
// WEBPACK FOOTER
// ./~/jszip/lib/defaults.js
// module id = 964
// module chunks = 0